import WorkerAutocompleteBaseController from "./worker_autocomplete_base"

export default class extends WorkerAutocompleteBaseController {
  static identifier = "mute-autocomplete"
  static targets = ["input", "datalist"]
  static values = { url: String }

  onInput() {
    this.onAutocompleteInput({ minQueryLength: 2, delay: 200 })
  }

  renderWorkerResults(workers) {
    const datalist = this.datalistTarget
    while (datalist.firstChild) datalist.removeChild(datalist.firstChild)

    workers.forEach(worker => {
      if (!worker?.name) return
      const option = document.createElement("option")
      option.value = worker.name
      datalist.appendChild(option)
    })
  }
}
